import { Alert, styled } from "@mui/material";

export const AlertLoginCustom = styled(Alert)(({theme}) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main, 
}))

